var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRightOrenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 7.83502 27.165 0 17.5 0V0C7.83502 0 0 7.83502 0 17.5V35H17.5C27.165 35 35 27.165 35 17.5V17.5Z",
    fill: "#C2B58C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1763 9.67569C12.7207 10.1313 12.7207 10.87 13.1763 11.3256L19.3514 17.5007L13.1763 23.6757C12.7207 24.1313 12.7207 24.87 13.1763 25.3256C13.632 25.7812 14.3706 25.7812 14.8263 25.3256L21.8263 18.3256C22.2819 17.87 22.2819 17.1313 21.8263 16.6757L14.8263 9.67569C14.3706 9.22008 13.632 9.22008 13.1763 9.67569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRightOrenge);
export default __webpack_public_path__ + "static/media/dashboard-right-orenge.d951a5b05f25c6c0e9b1b1c69dcce9d2.svg";
export { ForwardRef as ReactComponent };